import React from 'react';
import NumberFormatter from "../libs/NumberFormatter";

export default function Order(
    props: {
        selectedTicker: string,
        onBuyClick: (ticker: {symbol: string, amount: number}) => void,
        onSellClick: (ticker: {symbol: string, amount: number}) => void
    }
) {

    const selectedTicker = props.selectedTicker;
    const defaultAmount = 1000;

    return (
        <div className="absolute top-0 right-2 h-40 grid place-items-center">

            <div>
                <h3 className="text-sm leading-7"><span className="font-bold">Amount</span> {NumberFormatter.toCurrency(defaultAmount)}</h3>
                <button
                    className="px-3 py-2 mr-2 border border-green-500/90 rounded text-white
                    bg-green-500/90 hover:border-green-600/90 hover:bg-green-600/90"
                    onClick={() => props.onBuyClick({symbol: selectedTicker, amount: defaultAmount})}
                >
                    Buy
                </button>
                <button
                    className="px-3 py-2 border border-red-500/90 rounded text-white
                    bg-red-500/90 hover:border-red-600/90 hover:bg-red-600/90"
                    onClick={() => props.onSellClick({symbol: selectedTicker, amount: defaultAmount})}
                >
                    Sell
                </button>
            </div>

        </div>
    );

}